import { Observable, pipe, UnaryFunction } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

const selectDistincState = <T, I>(key: string): UnaryFunction<Observable<T>, Observable<I>> => pipe(
        map<T, I>(x => x[key]),
        distinctUntilChanged<I>()
    );

export default selectDistincState;
